import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
                 title,
                 description,
                 keywords,
                 canonicalUrl,
                 ogImage = 'https://nebulyx.ai/og-image.jpg',
                 ogType = 'website',
                 twitterImage = 'https://nebulyx.ai/twitter-image.jpg',
                 twitterCard = 'summary_large_image',
                 structuredData = null,
                 noIndex = false
             }) => (
    <Helmet>
        {/* Page Title */}
        {title && <title>{title}</title>}
        {title && <meta name="title" content={title} />}

        {/* Basic Meta Tags */}
        {description && <meta name="description" content={description} />}
        {keywords && <meta name="keywords" content={keywords} />}

        {/* Robots */}
        <meta name="robots" content={noIndex ? 'noindex, nofollow' : 'index, follow'} />

        {/* Canonical */}
        {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

        {/* Open Graph */}
        {title && <meta property="og:title" content={title} />}
        {description && <meta property="og:description" content={description} />}
        <meta property="og:type" content={ogType} />
        {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
        {ogImage && <meta property="og:image" content={ogImage} />}

        {/* Twitter */}
        <meta property="twitter:card" content={twitterCard} />
        {canonicalUrl && <meta property="twitter:url" content={canonicalUrl} />}
        {title && <meta property="twitter:title" content={title} />}
        {description && <meta property="twitter:description" content={description} />}
        {twitterImage && <meta property="twitter:image" content={twitterImage} />}

        {/* Structured Data */}
        {structuredData && (
            <script type="application/ld+json">
                {JSON.stringify(structuredData)}
            </script>
        )}
    </Helmet>
);

export default SEO;